<template>
  <v-container
    grid-list-md
    pt-0
  >
    <CustomerCondition
      ref="condition"
    />
    <v-layout row>
      <CustomerTable
        @select-customer="selected = $event"
      />
      <v-flex md4>
        <CustomerDetail
          v-if="selected"
          :selected="selected"
          @reset="resetSelected($event)"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { CustomerCondition } from './components'
import { CustomerDetail, CustomerTable } from '@/views/customers/components'

export default {
  components: {
    CustomerCondition,
    CustomerDetail,
    CustomerTable
  },

  data () {
    return {
      selected: null
    }
  },
  computed: {
    ...mapState('customers', ['result'])
  },
  methods: {
    resetSelected (id) {
      id = id || this.selected.id
      this.selected = this.result.find(c => c.id === id)
    }
  }
}
</script>
